import React, { useEffect } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { ConversationList } from '../components/ConversationList';
import { ChatWindow } from '../components/ChatWindow';
import { useConversationStore } from '@/stores/useConversationStore';
import { useOnboardingStore } from '@/stores/useOnboardingStore';
import { MOCK_CONVERSATION_ID } from '../mockData';
import { cn } from '@/lib/utils';

export const ConversationsPage: React.FC = () => {
  const { conversationId } = useParams<{ conversationId?: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const {
    activeConversationId,
    setActiveConversationId,
    setCustomerFilter,
  } = useConversationStore();

  const { hasSeenTour } = useOnboardingStore();

  useEffect(() => {
    const customerId = searchParams.get('customerId');
    const customerName = searchParams.get('customerName');
    
    if (customerId) {
      setCustomerFilter(customerId, customerName || null);
      // Clean up URL so the filter lives in the store without cluttering the URL
      navigate('/conversations', { replace: true });
    }
  }, [searchParams, setCustomerFilter, navigate]);

  // Synchronize route param with store state
  useEffect(() => {
    if (conversationId && conversationId !== activeConversationId) {
      setActiveConversationId(conversationId);
    } else if (!conversationId && activeConversationId && activeConversationId !== MOCK_CONVERSATION_ID) {
      setActiveConversationId(null);
    }
  }, [conversationId, activeConversationId, setActiveConversationId]);

  const effectiveConversationId = conversationId || (!hasSeenTour ? MOCK_CONVERSATION_ID : null);
  const hasSelectedConversation = Boolean(conversationId);

  return (
    <div className="h-full w-full flex overflow-hidden bg-background">
      {/* Left Pane: Conversation List */}
      <div
        className={cn(
          'w-full md:w-[380px] lg:w-[420px] shrink-0 h-full flex flex-col',
          hasSelectedConversation ? 'hidden md:flex' : 'flex'
        )}
      >
        <ConversationList className="h-full w-full" />
      </div>

      {/* Right Pane: Active Chat Window */}
      <div
        className={cn(
          'flex-1 h-full min-w-0 flex flex-col',
          !hasSelectedConversation ? 'hidden md:flex' : 'flex'
        )}
      >
        <ChatWindow
          conversationId={effectiveConversationId}
          className="h-full w-full"
        />
      </div>
    </div>
  );
};

export default ConversationsPage;
